type SpendVolumeOverview = {
    invoiceAmount: number[];
    earlyPaidAmount: number[];
    categories: string[];
};

type SpendVolume = {
    data: ChartItem[];
    categories: string[];
};

type TopSuppliersType = {
    data: number[];
    categories: string[];
};

type WorkingCapitalLift = {
    capitalAmount: number[];
    categories: string[];
};

type EarlyPaidAdoptionChart = {
    categories: string[];
    creditLimit: number;
    openInvoiceAmount: number[];
    fundedAmount: number[];
};

type AgingForecastChart = {
    data: ChartItem[];
    categories: string[];
    daysAhead: number;
};

type SupplierEnrollmentsChart = {
    enrollments: number[];
    categories: string[];
};

const ReportType = {
    SpendVolumeOverview: 'spend-volume-overview',
    SpendVolume: 'spend-volume',
    TopSuppliers: 'top-suppliers',
    WorkingCapitalLift: 'working-capital-lift',
    EarlyPaidAdoption: 'early-paid-adoption',
    EarlyPaidAmount: 'early-paid-amount',
    SupplierEnrollment: 'supplier-enrollment',
    SupplierEnrollmentDetails: 'supplier-enrollment-details',
    AgingForecast: 'aging-forecast'
};

const HighlightAnswer = {
    Yes: 'Top 10',
    No: 'None',
    EarlyPaid: 'Early Paid'
};

type ChartFilters = {
    highlighted: string;
    suppliers: string[];
};

type ColorRegistry = {
    [key: string]: string;
};

type ChartItem = {
    name: string;
    data: number[];
};

type ChartData = ChartItem[] | number[];

export {
    SpendVolumeOverview,
    SpendVolume,
    TopSuppliersType,
    WorkingCapitalLift,
    EarlyPaidAdoptionChart,
    SupplierEnrollmentsChart,
    AgingForecastChart,
    ReportType,
    HighlightAnswer,
    ChartFilters,
    ColorRegistry,
    ChartItem,
    ChartData
};
